import { clsx } from 'clsx'
import type { ReactNode } from 'react'

export default function Card({
  children,
  className,
  onClick,
}: {
  children: ReactNode
  className?: string
  onClick?: () => void
}) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'bg-surface-low border border-border-subtle rounded-lg p-5',
        onClick && 'cursor-pointer hover:border-border-subtle-hover transition-colors duration-150',
        className,
      )}
    >
      {children}
    </div>
  )
}
